<template>
      <v-row>
        <v-col v-for="(bar, i) in bars" :key="i">
<!--           <v-card color="grey lighten-4" flat height="65px"> -->
           
            <v-toolbar :color="bar.class" :dark="bar.dark" fixed>
              <v-menu offset-y dark permanent>
                <template v-slot:activator="{ on }">
                  <!-- <v-btn text slot="activator"> -->
                  <v-btn text v-on="on">
                    <v-app-bar-nav-icon></v-app-bar-nav-icon>
                  </v-btn>
                </template>
                <v-list class="container-fluid">
                  <!-- v-list-tile is changed to v-list-item -->
                  <v-list-item
                    v-for="menu in listMenus"
                    :key="menu.ID_MENU"
                    :to="{path: menu.URL}"
                  >
                    <v-list-item-title
                      ><center>
                        {{ (`${menu.DESCRIPTION}`) }}
                      </center></v-list-item-title
                    >
                  </v-list-item>
                  <v-list-item
                    v-on:click="dialog=true"
                  >
                    <v-list-item-content>
                      <v-list-item-title
                        ><center>
                            Change Password
                        </center></v-list-item-title
                      >
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-menu>
                <v-btn icon>
                <div class="logo">
                  <a href="#" class="simple-text logo__container">
                    <!-- <div class="logo-img" style="background-color: red"> -->
                    
                     <img src="img/logo_yayasan_zheng_dao.png" alt=""  style="
                        max-width: 50px;
                        max-height: 50px;
                        margin-right: 30px;
                      "/>
                    <!-- </div> -->
                  </a>
                </div>
              </v-btn>
              <v-toolbar-title>Yayasan Zheng Dao Li Shang Hu</v-toolbar-title>
              <v-spacer></v-spacer>

              <!-- <v-menu offset-y dark permanent>
                <template v-slot:activator="{ on }">
                  <v-btn text v-on="on">
                    <span>{{userName}}</span>
                  </v-btn>
                </template>
                <v-list class="container-fluid">
                  <v-list-item
                    @click="dialog=true"
                  >
                    <v-list-item-title
                      ><center>
                        Change Password
                      </center></v-list-item-title
                    >
                  </v-list-item>
                  <v-list-item
                    @click="logout"
                  >
                    <v-list-item-title
                      ><center>
                        Sign Out
                      </center></v-list-item-title
                    >
                  </v-list-item>
                </v-list>
              </v-menu> -->
              <!-- <v-btn text v-on:click="dialog=true">
                <span>Change Password</span>
              </v-btn> -->
              <v-btn text v-on:click="logout">
                <span>Sign Out</span>
              </v-btn>
            </v-toolbar>
<!-- 
          </v-card> -->
            <v-dialog
              v-model="dialog"
              v-if="dialog"
              width="500px"
            >
              <v-card
                class="ma-auto"
              >
                <FormGantiPassword
                @closeDialog="closeDialog"
                ></FormGantiPassword>
              </v-card>
            </v-dialog>
        </v-col>
      </v-row>
      
  
</template>
<script>
import SidebarLink from '../components/SidebarPlugin/SidebarLink.vue'
import axios from '@/axios'    
import FormGantiPassword from '../components/modal/FormGantiPassword.vue'
export
 default {
  computed: {
    routeName () {
      const {name} = this.$route
      return this.capitalizeFirstLetter(name)
    }
  },
  components: {
    SidebarLink,
    FormGantiPassword
  },
  data () {
    return {
      activeNotifications: false,
      authenticated: false,
      listMenus:[],
      isShowMenu:false,
      drawer: false,
      bars: [
        { class: '' },

      ],
      userName:'',
      dialog:false
    }
  },
    props: {

    sidebarLinks: {
      type: Array,
      default: () => []
    }
  },

   mounted() {
     this.user_id = this.$session.get('user_id');
          axios({
              method: 'post',
              url: 'getUserbyid',
              data: {
                  user_id: this.$session.get('user_id')
              },headers: {
                Authorization: 'Bearer ' + this.$session.get('token'),
              },
          }).then(response => {
              // console.log(response.data);
              this.userName=response.data[0];
              // console.log(response.data);
          }).catch(error=>{
              this.$router.push({name: "Login"});
          });
    // console.log(this.authenticated+' '+this.$session.get('role'));
      if(!this.authenticated && !this.$session.get('role')) {
          if(this.$router.name && this.$router.name!='Login'){
              this.$router.push({name: "Login"});
              // console.log(this.$router.name);
          }
          else{//Belum Login
              this.authenticated=false;
              // console.log('Here '+this.$router.name)
          }
      }else if(this.$session.get('role')){
      
          if(this.$session.get('role')!=='4' && this.$session.get('role')!=='5' )
          {
            this.isShow=true

          }else{
            this.isShow=false
            this.$sidebar.displaySidebar(false)

          }
          this.authenticated=true;


          axios({
              method: 'post',
              url: 'menu',
              data: {
                  role: this.$session.get('role')
              },headers: {
                Authorization: 'Bearer ' + this.$session.get('token'),
              },
          }).then(response => {
              // console.log(response.data);
              this.listMenus=response.data;
          }).catch(error=>{
              this.$router.push({name: "Login"});
          });
        
          // window.location.reload();
      }else{

        this.authenticated=true;
         axios({
              method: 'post',
              url: 'menu',
              data: {
                  role: this.$session.get('role')
              },headers: {
                Authorization: 'Bearer ' + this.$session.get('token'),
              },
          }).then(response => {
              // console.log(response.data);
              this.listMenus=response.data;
          }).catch(error=>{
              this.$router.push({name: "Login"});
          });
      } 

  },
  methods: {
    logout: function () {
      this.authenticated = false;
      this.$session.destroy()
      this.$router.push('/')
    },
    capitalizeFirstLetter (string) {
      return string.charAt(0).toUpperCase() + string.slice(1)
    },
    toggleNotificationDropDown () {
      this.activeNotifications = !this.activeNotifications
    },
    closeDropDown () {
      this.activeNotifications = false
    },
    toggleSidebar () {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar)
    },
    hideSidebar () {
      this.$sidebar.displaySidebar(false)
    },
    closeDialog(){
      this.dialog=false;
    }
  }
}
</script>
<style>
  


</style>
